import { render, staticRenderFns } from "./OptionalEntryAttributes.vue?vue&type=template&id=2a0af554&scoped=true"
import script from "./OptionalEntryAttributes.vue?vue&type=script&lang=js"
export * from "./OptionalEntryAttributes.vue?vue&type=script&lang=js"
import style0 from "./OptionalEntryAttributes.vue?vue&type=style&index=0&id=2a0af554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0af554",
  null
  
)

export default component.exports